module.exports = __webpack_public_path__ + "img/CHN@2x.cc0dbd7b.png";